<template xmlns="http://www.w3.org/1999/html">
  <div class="collect-con">
    <CommonHeader/>
    <div class="layout">
      <div style="float: right;margin-top: 60px" class="co-del" @click="AllDel()">批量删除</div>
      <div class="co-tit">已收藏题目</div>
      <div class="co-classify clearfix" v-if="questtionsArr && questtionsArr.length>0 && quesTypeArr && quesTypeArr.length>0">
        <div class="listBox">
          <b class="fdtit">类型：</b>
          <div>
            <span
              class="iconTxt"
              :class="{'on':item.isChoose===1}"
              v-for="(item,index) in quesTypeArr"
              :key="index"
              @click="changeType(index)">{{item.categoryName}}
            </span>
          </div>
        </div>
        <div class="listBox">
          <b class="fdtit">考场：</b>
          <div>
            <span
              class="iconTxt"
              :class="{'on':item.isChoose===1}"
              v-for="(item,index) in medMajors"
              :key="index"
              @click="changeMajor(index)">{{item.showName}}
            </span>
          </div>
        </div>
        <br>

        <div class="listBox" style="
                              overflow: hidden;>
                              margin-top: 30px;
                              margin-left: 0px;">
          <div class="del_box" style="display: none">
          <div class="fl" style="padding-top: 8px;">
          <input type="checkbox" id="checkbox" v-model="checked" @change="changeAllChecked()">
          <label for="checkbox" style="font: bolder;
                                       font-size: 18px
            ">
            全选取消收藏
          </label>
          </div>
          <div class="btn_fr fr">
            <div style="
                color: #ffffff;
                background: #59b948;
                height: 31px;
                width: 100px;
                border: 1px solid;
                line-height: 30px;
                float: left;
                cursor: pointer;
                margin-right: 8px;
              " @click="cancel()"><span style="margin-left: 32px;">取消</span></div>
            <div style="
                  color: #ffffff;
                  background: #59b948;
                  height: 31px;
                  width: 100px;
                  cursor: pointer;
                  border: 1px solid;
                  line-height: 30px;
                  float: right;
              " @click="AllDelColler()"><span style="margin-left: 25px;">删除</span>(<em class="del-count">0</em>)</div>
          </div>
          </div>
      </div>
        </div>


      <!--start-->
      <div class="co-main clearfix">
        <div class="subMain binder" v-if="questtionsArr && questtionsArr.length>0">
          <div v-for="(item,index) in questtionsArr" :key="index">
            <!--答题套小题-->
            <template v-if="item.childs && item.childs.length>0">
              <div class="subBox clearfix">
                <div class="subBox-tit">{{ index+1 }}、<span v-html="item.content"></span></div>
<!--                <div class="subBox-tit">{{ index+1 }}、<span v-html="item.content"></span></div>-->
              </div>
              <div v-for="(obj,idx) in item.childs" :key="idx" class=" clearfix" :class="obj.isFav == 1 || obj.otherFlag?'subBox':''">
                <div v-if="obj.isFav == 1 || obj.otherFlag">
                  <input class="el-checkbox" type="checkbox" :id="index" :value="obj.questionUserCollecID" v-model="checkedNames">
                  <div v-if="obj.quesTypeID ===1 || obj.quesTypeID === 3">
                    <div class="subBox-tit">{{ index+1}}.{{idx+1}}、<span v-html="obj.content"></span></div>
                    <div class="subBox-oneCon">
                      <div  v-for="(option,idx1) in obj.options" :key="idx1" :class="obj.optionFlag==1?'option-li':'list'">
                      <span  :class="{'on':obj.isRight}">
                        <input
                            :id="`${obj.questionID}_${obj.sequence}`"
                            type="radio"
                            name="singleAndJudge"
                            :value="option.quesValue"
                            @click="radioToggle(obj,option.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                      </div>
                    </div>
                    <div class="subBox-botCon">
                      <a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(obj.questionUserCollecID)" v-if="obj.isFav === 1">取消收藏</a>
                      <a class="collectionBtn as-an fr " href="javascript:void(0)" @click="addCollect(obj)" v-if="obj.isFav === 0">收藏</a>
                    </div>
                  </div>
                  <div v-if="obj.quesTypeID ===2">
                    <div class="subBox-oneCon">
                      <div  v-for="(option,idx1) in obj.options" :key="idx1" :class="obj.optionFlag==1?'option-li':'list'">
                      <span :class="{'on':obj.isRight}">
                        <input
                            :id="`${obj.questionID}_${obj.sequence}`"
                            type="checkbox"
                            name="multiple"
                            :value="obj.quesValue"
                            :checked="hasChecked(obj.userAnswer, obj.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                      </div>
                    </div>
                    <div class="subBox-botCon">
                      <a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(obj.questionUserCollecID)" v-if="obj.isFav === 1">取消收藏</a>
                      <a class="collectionBtn as-an fr " href="javascript:void(0)" @click="addCollect(obj)" v-if="obj.isFav === 0">收藏</a>
                    </div>
                  </div>
                  <div class="saglkd"  v-if="obj.isFav == 1 || obj.otherFlag">
                    <div class="saglkd-top clearfix" v-bind:class="obj.open?'answerItem':'activeItem'">
                      <a class="p_style" href="javascript:void(0)" @click="submitAnswer(obj)">{{obj.analysisMsg}}</a>
                    </div>
                  </div>
                  <div class="subBox-answerCon" v-if="obj.open">
                    <div class="satit clearfix">
                      <b class="clv">正确答案：{{ obj.rightAnswer }}</b>
                      <b class="chong">你的答案：{{ obj.userAnswer }}</b>
                    </div>
                    <div class="satxt">
                      <b class="fd">答案解析：</b><span v-html="obj.analysis"></span>
                    </div>
                    <div class="saglkd">
                      <b class="fd">关联考点：</b>
                      <div class="saglkd-top clearfix">
                        <span class="icon" v-for="(point,idx2) in obj.points" :key="idx2"><a href="javascript:void(0)">{{ point.pointName }}</a></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="saglkd">
                <div class="saglkd-top clearfix">
                  <a class="p_style watchOther" href="javascript:void(0)" @click="openOtherQues(item)">{{item.showMsg}}</a>
                </div>
              </div>
            </template>
            <!--单多判-->
            <template v-else>
              <div class="subBox clearfix">
                <div class="subBox-oneCon">
                  <div class="subBox-tit"><input class="el-checkbox" type="checkbox" :id="index" :value="item.questionUserCollecID" v-model="checkedNames">{{ index+1 }}、<span v-html="item.content"></span></div>
                    <div v-if="item.quesTypeID ===2">
                      <div class="list" v-for="(option,idx1) in item.options" :key="idx1">
                        <span :class="{'on':item.isRight}">
                          <input
                              :id="`${option.questionID}_${option.sequence}`"
                              type="checkbox"
                              name="multiple"
                              :value="option.quesValue"
                              @click="checkboxToggle(item,$event)"
                          />
                          {{ option.quesValue }}、{{ option.quesOption }}</span>
                      </div>
                    </div>
                    <div v-if="item.quesTypeID ===1 || item.quesTypeID === 3">
                      <div class="list" v-for="(option,idx1) in item.options" :key="idx1">
                      <span :class="{'on':item.isRight}">
                        <input
                            :id="`${option.questionID}_${option.sequence}`"
                            type="radio"
                            name="singleAndJudge"
                            :value="option.quesValue"
                            @click="radioToggle(item,option.quesValue)"
                        />
                        {{ option.quesValue }}、{{ option.quesOption }}</span>
                      </div>
                    </div>
                </div>
                <div class="saglkd">
                  <div class="saglkd-top clearfix" v-bind:class="item.open?'answerItem':'activeItem'">
                    <a class="p_style" href="javascript:void(0)" @click="submitAnswer(item)">{{item.analysisMsg}}</a>
                  </div>
                </div>
                <div class="subBox-answerCon" v-if="item.open">
                  <div class="satit clearfix">
                    <b class="clv">正确答案：{{item.rightAnswer}}</b>
                    <b class="chong">你的答案：{{item.userAnswer}}</b>
                  </div>
                  <div class="satxt">
                    <b class="fd">答案解析：</b><span v-html="item.analysis"></span>
                  </div>
                  <div class="saglkd">
                    <b class="fd">关联考点：</b>
                    <div class="saglkd-top clearfix">
                      <span class="icon" v-for="(point,idx2) in item.points" :key="idx2"><a href="javascript:void(0)">{{ point.pointName }}</a></span>
                    </div>
                  </div>
                </div>
                <div class="subBox-botCon"><a class="collectionBtn as-an fr on" href="javascript:void(0)" @click="openDia(item.questionUserCollecID)">取消收藏</a></div>
              </div>
            </template>
          </div>
        </div>
        <div class="nullBox" v-else>
          <div class="nullBox-pic"><img src="//member.med66.com/medqz/resources/images/2020mokaoxitong/null_02.jpg"></div>
          <div class="nullBox-txt">您还没有收藏题目，先收藏再来查看收藏记录吧<a href="javascript:void (0)" class="btn" @click="backToExam">去答题</a></div>
        </div>
      </div>
      <!--end-->
    </div>
    <CommonFooter/>
    <!--取消收藏弹框-->
    <cancelCollectDia :visible="cancelDia" @closeDialog="cancelDia=false" @cancelCollect="cancelCollect"></cancelCollectDia>
  </div>
</template>

<script>
import { getFavs,getFavCategoryMajors,deleteFavQues,addFavQues } from '@/api'
import { getCookie } from "@/utils";
import {CommonHeader, CommonFooter} from '@components/common'
import cancelCollectDia from "./cancelCollectDia";
export default {
  name: "index",
  components: {
    CommonHeader,
    CommonFooter,
    cancelCollectDia
  },
  data() {
    return {
      checked: false,
      checkedNames: [],
      cancelDia:false,
      questtionsArr:[],
      quesTypeArr:[],
      medMajors:[],
      questionUserCollecID:null, //收藏id
      courseID: null
    }
  },
  watch: {
    "checkedNames": function () {
      if (this.checkedNames.length == this.questtionsArr.length) {
        this.checked = true
        $(".del-count").text(this.checkedNames.length)
      } else {
        $(".del-count").text(this.checkedNames.length)
        this.checked = false
      }
    }
  },
  mounted() {
    this.getFavCategoryMajorsApi()
  },
  methods: {
    changeAllChecked: function() {
      if (this.checked) {
        var questionUserCollecIDs = new Array();
        this.questtionsArr.forEach( function (a){
          questionUserCollecIDs.push(a.questionUserCollecID);
        })
        this.checkedNames = questionUserCollecIDs;
        $(".del-count").text(this.checkedNames.length)
      } else {
        $(".del-count").text(0)
        this.checkedNames = []
      }
    },
    //获取类别
    getFavCategoryMajorsApi(){
      let params = {
        userID:Number(getCookie('cdeluid')),
      }
      getFavCategoryMajors(params).then(res => {
        this.quesTypeArr = res
        if(res && res.length>0){
          this.medMajors = res[0].medMajors
          this.courseID = this.medMajors[0].courseID
          this.getFavsApi()
        }
      })
    },
    AllDelColler(){
      console.log(this.checkedNames.length)
      if (this.checkedNames.length > 0){
        let params = {
          userID : Number(getCookie('cdeluid')),
          questionCollectionIDs : this.checkedNames
        }
        console.log(params)
        deleteFavQues(params).then(res => {
          this.getFavsApi()
        })
      }else {
        alert("请至少勾选一道题")
      }
    },
    radioToggle(obj,quesValue) {
      obj.userAnswer = quesValue;
      console.log(obj.userAnswer)
    },
    submitAnswer(obj) {
      if (!obj.open && obj.userAnswer){
        obj.open = true
        obj.analysisMsg = '收起答案解析'
      }else if (!obj.open && !obj.userAnswer){
        alert("请先作答")
      }else if (obj.open) {
        obj.analysisMsg = '提交答案并查看解析'
        obj.open = false
      }

    },
    //查看其他小题
    openOtherQues(obj) {
      if (obj.showFlag) {
        obj.showFlag = false;
        obj.showMsg = '收起本题其他小题'
        obj.childs.forEach(v => {
          if (!v.isFav) {
            v.otherFlag = true;
          }
        })
      }else {
        obj.showFlag = true;
        obj.showMsg = '查看本题其他小题'
        obj.childs.forEach(v => {
          if (!v.isFav) {
            v.otherFlag = false;
            v.open = false
          }
        })
      }

    },
    // 多选选择
    checkboxToggle(item,e) {
      let value = item.userAnswer?item.userAnswer : ''
      if (e.target.checked) {
        value += e.target.value
      }else {
        value = value.split(e.target.value).join("");
      }
      item.userAnswer = value
      console.log(value)
    },
    //切换类别
    changeType(index){
      this.quesTypeArr.forEach((val,idx) =>{
        if(idx===index){
          val.isChoose = 1
        }else{
          val.isChoose = 0
        }
      })
      this.cancel()
      this.medMajors = this.quesTypeArr[index].medMajors
      this.medMajors[0].isChoose = 1
      this.courseID = this.medMajors[0].courseID
      this.getFavsApi()
    },
    //切换考场
    changeMajor(index){
      this.medMajors.forEach((val,idx) =>{
        if(idx===index){
          val.isChoose = 1
          this.courseID = val.courseID
        }else{
          val.isChoose = 0
        }
      })
      this.getFavsApi()

    },
    //获取题目
    getFavsApi(){
      let params = {
        userID:Number(getCookie('cdeluid')),
        courseID:this.courseID,
        isAll:1
      }
      getFavs(params).then(res => {
        console.log(res)
        res.questions.forEach(e => {
          e.analysisMsg = '提交答案并查看解析'
          e.showMsg = '查看本题其他小题'
          e.showFlag = true
          e.open = false
          if (e.childs && e.childs.length >0) {
            e.childs.forEach(v => {
              v.analysisMsg = '提交答案并查看解析'
              v.open = false;
              v.otherFlag = false
              if (v.isFav == 1) v.otherFlag = true
              if (!v.options[0].quesOption) v.optionFlag = 1
              else v.optionFlag = 0
            })
          }
        })
        this.questtionsArr = res.questions
      })
    },

    openDia(questionUserCollecID){
      this.cancelDia = true
      this.questionUserCollecID = questionUserCollecID
    },
    //取消收藏
    cancelCollect(){
      let params = {
        userID:Number(getCookie('cdeluid')),
        questionCollectionIDs:[this.questionUserCollecID]
      }
      deleteFavQues(params).then(res => {
        this.cancelDia = false
        this.getFavsApi()
      })
    },
    //添加收藏
    addCollect(obj) {
      let params = {
        userID:Number(getCookie('cdeluid')),
        courseID:this.courseID,
        questionID:obj.questionID,
        chapterID:obj.chapterID
      }
      addFavQues(params).then(res => {
        obj.isFav = 1
        //this.cancelDia = false
        //this.getFavsApi()
      })
      console.log(params)
    },
    backToExam(){
      this.$router.push({
        path:'/entry'
      })
    },
    AllDel(){
      $(".del_box").show();
      $(".el-checkbox").show();
    },
    cancel(){
      this.checkedNames = []
      $(".del_box").hide();
      $(".el-checkbox").hide();
      this.checked = false
    }
  }
}

</script>
<style scoped lang="scss">
.wtachItem{
  padding:0 30px ;
}

.watchOther{
  color: #4ab83e;
}
.saglkd{
  overflow: hidden;
  .activeItem{
    height: 34px;
    text-align: center;
    line-height: 34px;
    border: 1px solid #4ab83e;
    margin-right: 10px;
    width: 220px;
    display: inline-block;
    border-radius: 18px;
    float: right;
    background: url('../../assets/images/entry/answerCard-toggle.png') no-repeat right -8px;
    background-position: 187px -58px;
    .p_style{
      color: #4ab83e;
    }
  }
  .answerItem{
    height: 34px;
    text-align: center;
    line-height: 34px;
    border: 1px solid #4ab83e;
    margin-right: 10px;
    width: 220px;
    display: inline-block;
    border-radius: 18px;
    float: right;
    background: url('../../assets/images/entry/answerCard-toggle.png') no-repeat right -8px;
    background-position: right -7px;
    .p_style{
      color: #4ab83e;
    }
  }
}

.nullBox {
  padding: 50px 0 100px;
  .nullBox-pic {
    display: block;
    width: 329px;
    height: 249px;
    margin: 0 auto;
  }
  .nullBox-txt {
    text-align: center;
    line-height: 66px;
    font-size: 16px;
    .btn {
      display: inline-block;
      padding: 0 30px;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      color: #4eb942;
      border: 1px solid #4eb942;
      border-radius: 18px;
      margin-left: 10px;
    }
  }
}
.option-li {
  float: left;
  margin-right: 40px;
  clear: none !important;
}
.option-li:nth-of-type(1){
  margin-left: 0 !important;
}
</style>
